<template>
  <details>
    <summary class="margin-left-l">{{type}}</summary>
    <meal-cards-group :meals="meals"/>
  </details>
</template>

<script>

import MealCardsGroup from './MealCardsGroup';

export default {
  name: 'MealTypeDetails',
  components: {MealCardsGroup},
  props: {
    type: {
      type: String,
      default: ''
    },
    meals: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables";

details {
  border: 2px solid black;
  border-radius: 4px;
  padding: .5em .5em 0;
}

::marker {
  color: black;
  font-size: 1.2em;
}

details summary {
  cursor: pointer;
}

details summary > * {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/MealTypeDetails.vue